import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

const maxRowItemSize = 40;

export const LensIcon = styled.img`
    width: ${maxRowItemSize}px;
    height: ${maxRowItemSize}px;
`;

export const IconSection = styled.div`
    display: flex;
    align-items: center;
`;

export const AdsAvailabilitySection = styled.div`
    display: flex;
    align-items: center;
`;

export const StatusSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    height: ${maxRowItemSize}px;
    padding-right: 5px;
`;

export const LensContainer = styled.div<{ hasErrors?: boolean }>`
    cursor: pointer;

    display: flex;
    align-items: center;

    padding: 0 24px;

    background-color: ${({ hasErrors }) => (hasErrors ? "#FEF7F8" : "#FFFFFF")};
    border-bottom: 1px solid ${Colors.Gray.V100};

    &:hover,
    &:focus {
        background-color: whitesmoke;
    }
`;

export const LensDataContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const lensDataContainerStyles = css`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const tableTextStyle = css`
    padding-right: 8px;
    font-size: 12px;
    line-height: 18px;
    color: ${Colors.Black.V100};
`;
